export const FREE_EMAIL_DOMAINS = new Set([
  'gmail.com',
  'googlemail.com',
  'yahoo.com',
  'yahoo.co.jp',
  'outlook.com',
  'hotmail.com',
  'live.com',
  'icloud.com',
  'me.com',
  'aol.com',
  'proton.me',
  'protonmail.com',
]);

export const getEmailDomain = (email = '') => {
  const parts = String(email).trim().toLowerCase().split('@');
  return parts.length === 2 ? parts[1] : '';
};

export const isFreeEmailAddress = (email = '') => FREE_EMAIL_DOMAINS.has(getEmailDomain(email));

export const isFreeEmailDomain = (domain = '') => FREE_EMAIL_DOMAINS.has(String(domain).trim().toLowerCase());
